// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/bonusprogram-" + chunkId + "." + {"1":"8d7a6cdf","2":"b09262a3","3":"78ba1a52","4":"491364a5","5":"7797d1fa","6":"caf9c8b6","7":"14082184","8":"69363a86"}[chunkId] + ".min.js";
};